import React, { Component, ReactNode } from 'react';

import { UI_TEXT } from '../constants';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ExternalAuthHandler Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center">
          <div className="mb-4 text-2xl text-gray-black">
            {UI_TEXT.FAILED_FALLBACK}
          </div>
          <div className="text-lg text-gray-black">
            {UI_TEXT.CLOSE_MESSAGE}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}